$shm_hitalama_resizer_side $rise_drag_view
	resize_side \right
	width? 320
	width_px \320px
	width_min 200
	width_max 1024
	y 0
	style *
		^
		display <= display \flex
		left <= left \auto
		right <= right \-6px
